module.exports = __webpack_public_path__ + "img/inputbtn.2179aa50.svg";